import { ISearchBox } from "@fluentui/react";
import { useEffect, useRef, useState } from "react";
import { IRequestAdminTableHistoricoIperc } from "../../Interfaces/IIpercBase";
import { InitialRequestAdminHistoricoIperc } from "../../utils/Initials/ListIperc";
import { IItemIPERC } from "../../Interfaces/IIPERC";
import { _formatDate } from "../../utils/helpers/dateHelpers";
import IPERCService from "../../services/IPERCService";
import { IPagination, IPaginationV2 } from "../../Interfaces/base/ITable";
import { _initialPagination } from "../../utils/helpers/helpers";

interface IFilterFechasDate {
  filterFechaInicio: Date | undefined;
  filterFechaFin: Date | undefined;
}
export const useIpercAdmin = () => {
  const controllerRef = useRef<AbortController>(new AbortController());
  const [filterFechas, setFilterFechas] = useState<IFilterFechasDate>({
    filterFechaInicio: new Date(),
    filterFechaFin: new Date(),
  });
  const [control, setControl] = useState(false)
  const searchBoxRefTable = useRef<ISearchBox>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState<IRequestAdminTableHistoricoIperc>(
    InitialRequestAdminHistoricoIperc
  );
  const _getPageSize = (value: number) => {
    setFilter({ ...filter, take: value })
  };
  const onChangePage = (value: number) => {
    const realSkip = (value * filter.take) - filter.take
    setFilter({ ...filter, skip: realSkip })
  };

  const [paginatiom, setPagination] = useState<IPaginationV2>({
    currentPage: 0,
    total: 0,
    pageSize: 0,
    skip: 0,
    take: 50,
    onPageChange: function (value: number): void {

    },
    onSizeChange: function (value: number): void {

    }
  })
  const [dataTable, setDataTable] = useState<IItemIPERC[]>([]);
  const _onkeyUpSearchTable = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };
  const onChangeComboBox = (e, o, text) => {
    if (e !== undefined) {
      switch (text) {
        case "actividad":
          if (o?.key) {
            setFilter({ ...filter, actividadId: o.key });
          }
          break;
        case "equipo":
          if (o?.key) {
            setFilter({ ...filter, equipoId: o.key });
          }
          break;
        case "supervisor":
          if (o?.key) {
            setFilter({ ...filter, supervisorId: o.key });
          }
          break;
        case "guardia":
          if (o?.key) {
            setFilter({ ...filter, guardia: o.key });
          }
          break;
        default:
          break;
      }
    }
  };
  const _onChangeChoiceGroup = (e, o) => {
    if (e !== undefined) {
      setFilter({ ...filter, estadoId: o.key });
    }
  };
  const _onSelectDate = (date, text) => {
    switch (text) {
      case "inicio":
        let fechaFin = !filterFechas.filterFechaFin || (filterFechas.filterFechaFin as unknown as Date) < date ? date : filterFechas.filterFechaFin;

        setFilterFechas({ ...filterFechas, filterFechaInicio: date, filterFechaFin: fechaFin });
        setFilter({ ...filter, fechaInicio: _formatDate(date, ","), fechaFin: fechaFin ? _formatDate(fechaFin, ",") : "" });
        break;
      case "fin":
        setFilter({ ...filter, fechaFin: _formatDate(date, ",") });
        setFilterFechas({ ...filterFechas, filterFechaFin: date });

        break;
      default:
        break;
    }
  };

  const postTableIperAdmin = () => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;
    setIsLoading(true);

    IPERCService.postTablaHistorial(filter, newController).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);
        setDataTable(res.data.items);
        const pag: IPaginationV2 = {
          currentPage: res.data.page,
          total: res.data.total,
          pageSize: res.data.pages,
          onPageChange: onChangePage,
          skip: filter.skip,
          take: filter.take,
          onSizeChange: _getPageSize
        }
        setPagination(pag)
      } else {
        setIsLoading(false);
      }
    });
  };
  const actualizarTabla = () => {
    postTableIperAdmin();
  };
  const limpiarFiltro = () => {
    setFilter(InitialRequestAdminHistoricoIperc);
    setFilterFechas({
      filterFechaFin: new Date(),
      filterFechaInicio: new Date(),
    });
    setControl(true)
  };

  useEffect(() => {
    if (control) {
      postTableIperAdmin();
      setControl(false)
    }
  }, [control])

  useEffect(() => {
    postTableIperAdmin();
  }, [filter]);
  

  return {
    limpiarFiltro,
    actualizarTabla,
    dataTable,
    filter,
    filterFechas,
    _onSelectDate,
    _onChangeChoiceGroup,
    onChangeComboBox,
    _onkeyUpSearchTable,
    isLoading,
    _getPageSize,
    searchBoxRefTable,
    paginatiom,
    postTableIperAdmin
  };
};
